import { render, staticRenderFns } from "./accounitngExpenses.vue?vue&type=template&id=975a6dcc&scoped=true&"
import script from "./accounitngExpenses.vue?vue&type=script&lang=js&"
export * from "./accounitngExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975a6dcc",
  null
  
)

export default component.exports